import React from 'react'
import { withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import LoadingScreen from 'components/complex/loadingScreen/LoadingScreen';
import SaveDialog from './SaveDialog';
import saveStatusValues from 'constants/status.save'
import { connect } from 'react-redux'
import { setSaveStatusClosed } from 'redux/actions'
import SaveDialogError from './SaveDialogError';
import SaveDialogInfo from "./SaveDialogInfo";

const style = theme => ({
	root: {

	}
})

function Save({
	classes,
	state,
	setSaveStatusClosed,
}) {
	const handleCloseDialog = () => {
		setSaveStatusClosed();
	}

	let isChecked = localStorage.getItem('show_save_popup')
	switch (state) {
		case saveStatusValues.CLOSED: return '';
		case saveStatusValues.DIALOG: return isChecked === 'true' ? "" : <SaveDialog onClose={handleCloseDialog} />;
		case saveStatusValues.DELETE: return isChecked === 'true' ? "" : <SaveDialog showDelete onClose={handleCloseDialog} />;
		case saveStatusValues.ERROR: return <SaveDialogError onClose={handleCloseDialog} />
		case saveStatusValues.INFO: return <SaveDialogInfo onClose={handleCloseDialog} />
		default: return <LoadingScreen />;
	}
}

Save.propTypes = {
	classes: PropTypes.any,
}

Save.defaultProps = {
}

export default connect((state) => ({
	state: state.store.saveStatus
}), {
	setSaveStatusClosed
})(withStyles(style)(Save));